var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.917,
    height: 14.333,
    viewBox: "0 0 17.917 14.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-email",
    "data-name": "Icon material-email",
    d: "M19.125,6H4.792A1.789,1.789,0,0,0,3.009,7.792L3,18.542a1.8,1.8,0,0,0,1.792,1.792H19.125a1.8,1.8,0,0,0,1.792-1.792V7.792A1.8,1.8,0,0,0,19.125,6Zm0,3.583-7.167,4.479L4.792,9.583V7.792l7.167,4.479,7.167-4.479Z",
    transform: "translate(-3 -6)",
    fill: "#ff6f00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2d246168a3988a35858f094fa65eab31.svg";
export { ForwardRef as ReactComponent };